import { post, get, put } from '../utils/request' // reqDelete 删除

export default {
  // 微信公众号
  getNtas: (data) => get('/jssdk/getNtas', data), // 获取JSSDK
  wechatAuthorize: (data) => get('/wechat/authorize', data), // 获取用户信息
  wechatUserInfo: (data) => get('/wechat/userInfo', data), // 获取用户信息
  /* 我的就诊人 */
  getByAppletsId: (data) => get('/api/patient/getByAppletsId', data), // 获取用户信息
  addPatient: (data) => post('/api/patient/addPatient', data), // 新增患者信息
  updPatient: (data) => post('/api/patient/updPatient', data), // 新增患者信息
  delPatient: (data) => post('/api/patient/delPatient', data), // 解绑患者信息
  updatePatient: (data) => post('/api/patient/updatePatient', data), // 设置默认就诊人
  getPatientListVo: (data) => get('/api/patient/getPatientListVo', data), // 获取就诊人列表
  getPatientInfo: (data) => get('/api/patient/getPatient', data), // 获取就诊人详情
  patientList: (data) => get('/api/patient/list', data), // 患者信息
  adAdministrativeRegionVoList: (data) => get('/administrativeregion/adAdministrativeRegionVoList', data), // 行政区划(下拉)

  /* 预约挂号 */
  getAdminList: (data) => post('/admin/list', data), // 获取科室
  deptTree: (data) => get('/api/dept/tree', data), // 根据父节点获取部门树结构
  deptList: (data) => get('/api/dept/list', data), // 部门列表搜索
  getKeepRange: (data) => post('/api/keep/getKeepRange', data), // 医师日期 能否挂号
  findByKeyword: (data) => get('/api/keep/findByKeyword', data), // 医生科室搜索 传参搜医生与科室 不传参搜科室
  registerPage: (data) => post('/api/register/registerInfo', data), // 就诊记录分页
  registerDetail: (data) => get(`/api/register/detail/${data.id}`), // 挂号详情
  getKeeps: (data) => get('/api/keep/gjyy/getKeeps', data), // 科室排班
  getKeep: (data) => get('/api/keep/getKeep', data), // 科室排班
  getDoctorList: (data) => get('/api/doctor/gjyy/getDoctorList', data), // 科室查医生
  appointment: (data) => post('/api/register/appointment', data), // 挂号
  registerCancel: (data) => put('/api/register/update', data), // 取消挂号
  getMsKeep: (data) => post('/api/keep/ms/getMsKeep', data), // 取消挂号
  /* 医院信息 */
  getGuidebook: (data) => get('/api/guidebook/getGuidebook', data), // 获取就医指南
  hospital: (data) => get('/api/hospital/hospital/one/1', data), // 获取医院介绍
  /* 报告查询 */
  getInspectReport: (data) => post('/api/inspection/inspect/szsxcgjyy/getInspectReport', data), // 检验报告列表
  getGjyyReportList: (data) => get('/api/inspection/inspection/gjyy/getReportList', data), // 检验报告列表
  getReportDetail: (data) => get('/api/inspection/inspection/gjyy/getReportDetail', data), // 检验报告详情
  msGetPdf: (data) => get('/api/inspection/inspection/ms/getPdf', data), // 检验报告pdf
  getEinvoiceDetailsById: (data) => get('/api/chargeDetail/getEinvoiceDetailsById', data), // 获取电子发票
  /* 缴费 */
  gjyyPay: (data) => put('/api/chargeInfo/gjyy/pay', data), // 支付
  wechatPay: (data) => post('/api/chargeInfo/wechat/update', data), // 自费费支付
  chargeList: (data) => post('/api/chargeInfo/chargeList', data), // 门诊缴费列表
  chargeListPage: (data) => get('/api/chargeInfo/chargeListPage', data), // 门诊缴费列表
  getChargeDetailsByClinicNo: (data) => get('/api/chargeDetail/getChargeDetailsByClinicNo', data), // 缴费明细
  getChargeAndPatientId: (data) => get(`/api/chargeInfo/getChargeAndPatientId/${data.id}`, data), // 缴费详情
  /* 预检分诊表 */
  precheckGetList: (data) => get('/api/precheck/getList', data),
  precheckAdd: (data) => post('/api/precheck', data),
  precheckDetail: (data) => get(`/api/precheck/one/${data.id}`),
  detailInit: (data) => get('/api/precheck/detailInit', data), // 查询患者有没有填写过预检分诊
  precheckPatientList: (data) => get('/api/precheck/patientList', data), // 获取填写人列表
  getListByPatientId: (data) => get('/api/precheck/getListByPatientId', data), // 获取患者有没有填写预检分诊表
  addPatientRemark: (data) => post('patientRemark/addPatientRemark', data), // 患者留言-添加
  /* 医生介绍 */
  getDoctor: (data) => get('/api/doctor/getSzsgjyyDoctorList', data), // 科室查医生
  getDoctorInfo: (data) => get('/api/doctor/getSzsgjyyDoctorInfo', data), // 医生介绍详情
  getDept: (data) => get('/api/dept/getDept', data), // 医生介绍详情
  hospitalDetail: (data) => get('/api/hospital/hospital/detail', data), // 医院介绍详情
  healthheadlinesList: (data) => get('/api/healthheadlines/list', data), // 获取健康头条列表
  healthheadlinesDetail: (id) => get(`/api/healthheadlines/detail/${id}`), // 获取健康头条详情
  problemmanageList: (data) => get('/api/problemmanage/list', data), // 获取问题列表
  problemmanageDetail: (id) => get(`/api/problemmanage/detail/${id}`), // 获取问题详情
  feedbackmanageAdd: (data) => post('/api/feedbackmanage/add', data), // 获取问题列表
  /* 住院 */
  addPatientZyBinding: (data) => post('/api/patientzybinding/addPatientZyBinding', data), // 添加患者住院人绑定
  updPatientZyBinding: (data) => post('/api/patientzybinding/updPatientZyBinding', data), // 修改患者住院人绑定
  delPatientZyBindingByID: (data) => get(`/api/patientzybinding/delPatientZyBindingByID/${data}`), // 删除住院人绑定信息
  getPatientZyBindingByID: (data) => get(`/api/patientzybinding/getPatientZyBindingByID/${data}`), // 查看住院人绑定信息
  getPatientZyBindingList: (data) => get(`/api/patientzybinding/getPatientZyBindingList/${data}`), // 患者住院人绑定列表
  getPatientZyInfo: (data) => post('/api/patientzy/getPatientZyInfo', data), // 获取住院费用清单
  getZyInspectionReportInfo: (data) => post('/api/patientzy/getZyInspectionReportInfo', data), // 获取住院费用清单
  getZYPaymentInAdvanceInfo: (data) => post('/api/patientzy/getZYPaymentInAdvanceInfo', data), // 获取预交金缴费记录
  getZYPatientZyExamineInfo: (data) => post('/api/patientzy/getZYPatientZyReport', data), // 住院检查报告
  getZYPatientZyReport: (data) => post('/api/patientzy/getZYPatientExaminationReport', data), // 住院检查报告
  getZYPatientZyReportDetail: (data) => post('/api/patientzy/getZYPatientZyReportDetail', data), // 获取住院检验报告详情
  zyPay: (data) => post('/api/patientzy/zyPay', data), // 住院费用缴纳(小马哥支付)
  getSzsgjyyDoctorJobList: (data) => get('/api/doctor/getSzsgjyyDoctorJobList', data), // 职称列表
  getSzsgjyyDoctorJobTitleInfo: (data) => get('/api/doctor/getSzsgjyyDoctorJobTitleInfo', data), // 职称列表
  getGjyyDoctorKeeps: (data) => get('/api/keep/gjyy/getGjyyDoctorKeeps', data), // 职称列表

  /**
   *体检
   */

  /**
   *就诊人信息
   */
  testedPersonList: (data) => get('/api/person-manage/testedPersonList', data), // 获取就诊人列表
  addTestedPerson: (data) => post('/api/person-manage/addTestedPerson', data), // 新增就诊人
  updateTestedPerson: (data) => post('/api/person-manage/updateTestedPerson', data), // 修改就诊人
  getTestedPersonById: (data) => get('/api/person-manage/getTestedPersonById', data), // 获取就诊人详情
  deleteTestedPerson: (data) => get('/api/person-manage/deleteTestedPerson', data), // 删除就诊人

  /* 复诊 */
  reRegisterPage: (data) => get('/api/register/reRegisterPage', data), // 可复诊就诊记录

  /*
    体检套餐
   */
  appMainPacks: (data) => get('/api/app-pack/appMainPacks', data), // 套餐列表
  appPackDetails: (data) => get('/api/app-pack/appPackDetails', data), // 套餐详情
  appPackPayment: (data) => post('/api/app-pack/appPackPayment', data), // 找套餐-提交订单
  expireOrderInfo: (data) => get('/api/app-pack/expireOrderInfo', data), // 待支付订单详情
  cancelOrder: (data) => get('/api/app-pack/cancelOrder', data), // 取消体检订单
  payOrder: (data) => post('/api/app-pack/payOrder', data), // 订单重新支付

  /*
    体检预约记录
   */
  appPersonPackOrders: (data) => get('/api/app-pack/appPersonPackOrders', data), // 预约记录
  cancelPack: (data) => get('/api/app-pack/cancelPack', data), // 取消预约
  /*
    体检报告
   */
  getTJReport: (data) => get('/api/app-pack/getTJReport', data), // 列表
  getTJReportInfo: (data) => get('/api/app-pack/getTJReportInfo', data), // 详情
  getTJReportPdf: (data) => get('/api/app-pack/getTJReportPdf', data), // 报告PDF

  /* 电子发票*/
  getInvoiceList: (id, data) => get('/api/problemmanage/getInvoiceList/' + id, data)
}
